import React from "react";
import { Settings, DesktopMac, FilterVintage, Timeline, EmojiSymbols } from "@material-ui/icons";
export const menus = [
  {
    id: "dashboard",
    title: "Dashboard",
    muiIcon: () => <DesktopMac style={{ margin: 0 }} />,
    path: "/user",
  },
  {
    id: "morning-history",
    title: "Morning/Anytime",
    muiIcon: () => <FilterVintage style={{ margin: 0 }} />,
    path: "/user/history/morning",
  },
  {
    id: "biofeedback-history",
    title: "Bio/Mindfulness",
    muiIcon: () => <Timeline style={{ margin: 0 }} />,
    path: "/user/history/biofeedback-mindfulness",
  },
  // {
  //   id: "mindfulness-history",
  //   title: "Mindfulness",
  //   muiIcon: () => <EmojiSymbols style={{ margin: 0 }} />,
  //   path: "/user/history/mindfulness",
  // },
  {
    id: "settings",
    title: "Settings",
    muiIcon: () => <Settings style={{ margin: 0 }} />,
    path: "/user/history/self-compassion",
  },
];
